// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__9G9Hj","content":"styles_content__3dZIo","checkbox":"styles_checkbox__2fvx6","checkboxLabel":"styles_checkboxLabel__MXl_T"};